import { render, staticRenderFns } from "./AmbassadorTools.vue?vue&type=template&id=679a5266&"
import script from "./AmbassadorTools.vue?vue&type=script&lang=js&"
export * from "./AmbassadorTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports